import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import HeadingCp from '../components/HeadingCp';
import EstimateBar from '../components/EstimateBar';

const InstallationDetailPage = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const { id, key } = useParams();

  const [loading, setLoading] = useState(false);

    // State for services
  const [services, setServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState({});

  // State for the "system" – the user’s actual mark-up data
  const [submitObject, setSubmitObject] = useState({
    estimate_id: '',
    job_mark_up: '',
    sub_mark_up: '',
    discount: '',
  });

  // State for the "builder" – the maximum allowed values
  const [limitObject, setLimitObject] = useState({
    job_mark_up: '',
    sub_mark_up: '',
    discount: '',
  });

  /* -------------------- FETCH Mark-Up Data (builder & system) -------------------- */
  useEffect(() => {
    const fetchMarkUpData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${apiUrl}/best_crud.php`, {
          params: {
            estimate: id,
            builder_id: key,
            getMarkUp: true,
          },
        });
        console.log('MarkUp fetch =>', response.data);

        if (response.data[0] === 'success') {
          // e.g. response.data = ["success", "builder": {...}, "system": {...}]
          // We'll store builder-limits in limitObject, actual data in submitObject
          const builderData = response.data.builder || {};
          const systemData  = response.data.system || {};
          console.log('Builder Data =>', builderData);
          

          setLimitObject({
            job_mark_up: parseFloat(builderData.job_mark_up) || 0,
            sub_mark_up: parseFloat(builderData.sub_mark_up) || 0,
            discount: parseFloat(builderData.discount) || 0,
          });

          setSubmitObject({
            estimate_id: id,
            job_mark_up: parseFloat(systemData.job_mark_up) || 0,
            sub_mark_up: parseFloat(systemData.sub_mark_up) || 0,
            discount: parseFloat(systemData.discount) || 0,
          });
        } else {
          toast.error('No mark-up data found.', { position: 'top-center' });
        }
      } catch (error) {
        toast.error('Error fetching mark-up data.', { position: 'top-center' });
      } finally {
        setLoading(false);
      }
    };

    if (id && key) {
      fetchMarkUpData();
    }
  }, [id, key, apiUrl]);

  /* -------------------- SAVE Mark-Up Data (system) -------------------- */
  const saveMarkUpData = async (e) => {
    e.preventDefault();
    try {
      // We post "system" data – the user’s actual values
      const bodyData = {
        status: 'saveMarkUp',
        estimate_id: id,
        data: {
          job_mark_up: submitObject.job_mark_up,
          sub_mark_up: submitObject.sub_mark_up,
          discount: submitObject.discount,
        },
      };
      console.log('bodyData Mark-Up data =>', bodyData);

      const response = await axios.post(`${apiUrl}/best_crud.php`, bodyData, {
        headers: { 'Content-Type': 'application/json' },
      });

      console.log('Mark-Up save response =>', response.data);
      if (response.data[0] === 'success') {
        toast.success('Mark-up data saved!', { position: 'top-center' });
      } else {
        toast.error(response.data.error || 'Failed updating Mark-Up.', { position: 'top-center' });
      }
    } catch (error) {
      toast.error('Error saving Mark-Up data.', { position: 'top-center' });
      if (error.response && error.response.status === 401) {
        navigate('/login');
      }
    }
  };

  /* -------------------- Handle Changes with Limits -------------------- */
  const handleMarkUpChange = (e) => {
    const { name, value } = e.target;
    const numericValue = parseFloat(value) || ''; // fallback to 0 if blank
    // Compare with limit if name in [job_mark_up, sub_mark_up, discount]
    if (name === 'job_mark_up') {
      if (numericValue < parseInt(limitObject.job_mark_up)) {
        toast.info(`Job mark-up can't exceed ${limitObject.job_mark_up}`, { position: 'top-center' });
        return;
      }
    } else if (name === 'sub_mark_up') {
      if (numericValue < limitObject.sub_mark_up) {
        toast.info(`Sub mark-up can't exceed ${limitObject.sub_mark_up}`, { position: 'top-center' });
        return;
      }
    } else if (name === 'discount') {
      if (numericValue > limitObject.discount) {
        toast.info(`Discount can't exceed ${limitObject.discount}`, { position: 'top-center' });
        return;
      }
    }

    setSubmitObject((prev) => ({
      ...prev,
      [name]: numericValue,
    }));
  };

  /* -------------------- SERVICES SECTION -------------------- */
  // 1) Fetch the services
  useEffect(() => {
    const fetchServices = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${apiUrl}/best_crud.php`, {
          params: {
            estimate: id,
            builder_id: key,
            serviceMarkUp: true, // Or however your server endpoint is named
          },
        });
        console.log('Services fetch =>', response.data);
        
        if (response.data[0] === 'success') {
          setServices(response.data[1]);
        } else {
          // toast.error('No services found.', { position: 'top-center' });
        }
      } catch (error) {
        toast.error('Error fetching services.', { position: 'top-center' });
      } finally {
        setLoading(false);
      }
    };
    if (id && key) {
      fetchServices();
    }
  }, [id, key, apiUrl]);

  // 2) Save the services selections
const handleSubmitServices = async (e) => {
  e.preventDefault();
  console.log("Selected services =>", selectedServices);

    // 1) Build a copy of selectedServices that excludes "None" or any toggled off
    const dataToSend = { ...selectedServices };
    // If "None" means unselected, remove that category
    Object.entries(dataToSend).forEach(([catName, value]) => {
      if (value === "None") {
        delete dataToSend[catName];
      }
    });

    // 2) Prepare the bodyData
    const bodyData = {
      status: "saveServices",
      estimate_id: id,
      data: dataToSend, // The user-chosen services (without “None”)
    };
    console.log(bodyData);
    

  // try {
  

  //   // 3) Send to your endpoint
  //   const response = await axios.post(`${apiUrl}/best_crud.php`, bodyData, {
  //     headers: { "Content-Type": "application/json" },
  //   });
  //   console.log("Services save response =>", response.data);

  //   // 4) Handle the response
  //   if (response.data[0] === "success") {
  //     toast.success("Services saved successfully!", { position: "top-center" });
  //   } else {
  //     toast.error(response.data.error || "Failed saving services.", {
  //       position: "top-center",
  //     });
  //   }
  // } catch (error) {
  //   toast.error("Error saving services.", { position: "top-center" });
  //   if (error.response && error.response.status === 401) {
  //     navigate("/login");
  //   }
  // }
};

  // For services with <=2 items => checkboxes, else => radio + "None"
  // Instead of storing an array of item IDs, we store a single item ID per category
// For services with <=2 items => checkboxes, 
// but each category can only have one item selected at a time.
  const handleCheckboxChange = (catName, itemId, checked) => {
    setSelectedServices((prev) => {
      const currentSelection = prev[catName];

      // Case 1: User is checking the box
      if (checked) {
        // If they check the same item that’s already selected, remove it
        if (currentSelection === itemId) {
          const { [catName]: _, ...rest } = prev;
          return rest;
        } else {
          // Otherwise, set catName => itemId
          return {
            ...prev,
            [catName]: itemId,
          };
        }
      } 
      // Case 2: User is unchecking the box
      else {
        // If user unchecks, remove catName from the object
        const { [catName]: _, ...rest } = prev;
        return rest;
      }
    });
  };

  const handleRadioChange = (catName, value) => {
    setSelectedServices((prev) => {
      const currentSelection = prev[catName];

      // If the user picks the same value that is already selected, remove (unselect) it
      if (currentSelection === value) {
        const { [catName]: _, ...rest } = prev;
        return rest; // effectively toggling off
      } else {
        // Otherwise, set catName => this new value
        return {
          ...prev,
          [catName]: value,
        };
      }
    });
  };

  useEffect(() => {
  // Once categories is fetched, find the default selected items
  const newSelections = {};
  services.forEach((catBlock) => {
    const catName = catBlock.cat;
    catBlock.list.forEach((item) => {
      if (item.selected) {
        // If the API says item.selected === true, mark it in state
        newSelections[catName] = item.id;
      }
    });
  });
  setSelectedServices((prev) => ({ ...prev, ...newSelections }));
}, [services]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="mx-auto max-w-[1200px] sm:px-6 lg:px-6 py-8 bg-white">
      <EstimateBar id={id} name={'markup-service'} builder_id={key} />
      <HeadingCp label={'Mark Ups & Services'} />

      {/* ---------- MARK-UP / DISCOUNT FORM  ---------- */}
      <section className="w-[800px] px-8 mx-auto mb-10 border-b pb-6">
        <h2 className="text-lg font-semibold mb-4">Mark-Up and Discount</h2>

        <form onSubmit={saveMarkUpData}>
          <div className="flex flex-wrap gap-6 mb-4">
            {/* Job Mark-up */}
            <div className="flex-1 flex flex-col space-y-1">
              <label htmlFor="job_mark_up" className="text-sm font-medium text-gray-900">
                Job Mark-up (%):
              </label>
              <input
                type="number"
                id="job_mark_up"
                name="job_mark_up"
                className="w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                value={submitObject.job_mark_up || limitObject.job_mark_up}
                onChange={handleMarkUpChange}
                required
              />
              <small className="text-xs text-gray-500">
                Min allowed: {limitObject.job_mark_up}
              </small>
            </div>

            {/* Sub-contract Mark-up */}
            <div className="flex-1 flex flex-col space-y-1">
              <label htmlFor="sub_mark_up" className="text-sm font-medium text-gray-900">
                Sub-contract Mark-up (%):
              </label>
              <input
                type="number"
                id="sub_mark_up"
                name="sub_mark_up"
                className="w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                value={submitObject.sub_mark_up || limitObject.sub_mark_up}
                onChange={handleMarkUpChange}
                required
              />
              <small className="text-xs text-gray-500">
                Min allowed: {limitObject.sub_mark_up}
              </small>
            </div>

            {/* Discount */}
            <div className="flex-1 flex flex-col space-y-1">
              <label htmlFor="discount" className="text-sm font-medium text-gray-900">
                Manufacture Discount (%):
              </label>
              <input
                type="number"
                id="discount"
                name="discount"
                className="w-full rounded-md border-gray-300 shadow-sm sm:text-sm"
                value={submitObject.discount || limitObject.discount}
                onChange={handleMarkUpChange}
                required
              />
              {/* <small className="text-xs text-gray-500">
                Max allowed: {limitObject.discount}
              </small> */}
            </div>
          </div>

          <button
            type="submit"
            className="px-4 py-2 bg-blue-600 text-white font-semibold rounded"
          >
            Save Mark-Up
          </button>
        </form>
      </section>

      {/* ---------- SERVICES FORM  ---------- */}
      {services.length > 0 ? (
        <section className="w-[800px] px-8 mx-auto">
        <h2 className="text-lg font-semibold mb-4">Services</h2>
        <form onSubmit={handleSubmitServices}>
          {services.map((catBlock, catIndex) => {
            const catName = catBlock.cat;
            const items = catBlock.list;
            const isRadio = items.length >= 3;

            return (
              <div key={catIndex} className="mb-6 border-b pb-4">
                <h3 className="text-md font-semibold mb-2">{catName} Services</h3>

              {!isRadio ? (
                items.map((item) => {
                  const currentId = selectedServices[catName];
                  const checked = currentId === item.id;

                  return (
                    <div key={item.id} className="flex items-center mb-2">
                      <input
                        type="checkbox"
                        id={`check-${catName}-${item.id}`}
                        checked={checked}
                        onChange={(e) => handleCheckboxChange(catName, item.id, e.target.checked)}
                        className="h-4 w-4 text-indigo-600 border-gray-300"
                      />
                      <label
                        htmlFor={`check-${catName}-${item.id}`}
                        className="ml-2 text-sm text-gray-700"
                      >
                        {item.name} (${item.price})
                      </label>
                    </div>
                  );
                })
                ) : 
                (
                  /* If >= 3 items => radio + "None" option */
                  <div className="space-y-2">
                    {items.map((item) => {
                      const selectedVal = selectedServices[catName];
                      return (
                        <div key={item.id} className="flex items-center">
                          <input
                            type="radio"
                            id={`radio-${catName}-${item.id}`}
                            name={`radioGroup-${catName}`}
                            value={item.id}
                            checked={selectedVal === item.id}
                            onChange={() => handleRadioChange(catName, item.id)}
                            className="h-4 w-4 text-indigo-600 border-gray-300"
                          />
                          <label
                            htmlFor={`radio-${catName}-${item.id}`}
                            className="ml-2 text-sm text-gray-700"
                          >
                            {item.name} (${item.price})
                          </label>
                        </div>
                      );
                    })}

                    {/* "None" option */}
                    <div className="flex items-center">
                      <input
                        type="radio"
                        id={`radio-none-${catName}`}
                        name={`radioGroup-${catName}`}
                        value="None"
                        checked={selectedServices[catName] === 'None'}
                        onChange={() => handleRadioChange(catName, 'None')}
                        className="h-4 w-4 text-indigo-600 border-gray-300"
                      />
                      <label htmlFor={`radio-none-${catName}`} className="ml-2 text-sm text-gray-700">
                        None
                      </label>
                    </div>
                  </div>
                )}
              </div>
            );
          })}

          <button
            type="submit"
            className="px-4 py-2 mt-4 bg-green-600 text-white font-semibold rounded"
          >
            Save Services
          </button>
        </form>
        </section>
      )
      : 
      (
        <section className="w-[800px] px-8 mx-auto">
          <p>No services available.</p>
        </section>
      )
    }

    </div>
  );
};

export default InstallationDetailPage;
